import styled from 'styled-components'
import { FormControlLabel as MuiFormControlLabel } from '@material-ui/core'
import { List, Button } from '@gympass/yoga'

import getBreakpoint from '@client/utils/breakpoints'

import Image from '@components/Image'

import { H6 } from '@components/Text'

export const TabWrapper = styled.section`
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-top: 40px;

  @media (min-width: ${getBreakpoint('xl')}px) {
    width: 480px;
  }
`

export const ListWrapper = styled.section`
  flex: 1;
  padding-left: 20px;
  padding-right: 20px;

  @media (min-width: ${getBreakpoint('xl')}px) {
    padding-left: 64px;
    padding-right: 64px;
  }
`

export const ListItem = styled(List.Item)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0 12px;

  .MuiFormControlLabel-root {
    margin-right: 0;
    margin-left: 0;
  }
`

export const ListItemText = styled(H6)`
  font-weight: 400;
  line-height: 64px;
  color: var(--secondary-text);
`

export const TabButton = styled(Button)`
  border-radius: 0px;
  height: 64px;
`

export const FormControlLabel = styled(MuiFormControlLabel)`
  display: flex;
  justify-content: space-between;
  width: 100%;
`

export const CountryIcon = styled(Image)`
  width: 24px;
  height: 24px;
  margin-right: 16px;
`
